import UserWalletAccountsPanel from './UserWalletAccountsPanel';

export default UserWalletAccountsPanel;
